module.exports = __webpack_public_path__ + "static/media/thumbnail.01bc5822.png";